export const SCREENS = {
  WELCOME: 0,
  ROLE: 1,
  GOAL: 2,
  CHANNELS: 3,
  LIST: 4,
  DNS: 5,
  TIMELINE: 6,
  REFERRAL: 7
};

export const ROLE_OPTIONS = [
  {
    value: 'marketer',
    label: 'I run marketing at my company',
    description: "Campaigns, lists, performance — that's my world"
  },
  {
    value: 'founder',
    label: 'I own or co-found the business',
    description: 'I make the final call on tools and spend'
  },
  {
    value: 'developer',
    label: "I'm a developer or technical lead",
    description: "I'm here to integrate APIs or build messaging infrastructure"
  },
  {
    value: 'agency',
    label: 'I manage marketing for clients',
    description: 'I run campaigns on behalf of multiple businesses'
  },
  {
    value: 'evaluator',
    label: "I'm exploring for someone else",
    description: "I'm gathering information before recommending a tool"
  }
];

export const GOAL_OPTIONS = [
  {
    value: 'marketing',
    label: 'Market to my audience',
    description: "Campaigns, newsletters, promotions — and automations when I'm ready"
  },
  {
    value: 'transactional',
    label: 'Send automated emails from my app',
    description: 'OTPs, receipts, alerts — triggered by my system'
  },
  {
    value: 'both',
    label: 'Both',
    description: 'I need marketing and transactional in one place'
  }
];

export const CHANNEL_OPTIONS = [
  {
    value: 'email',
    label: 'Email',
    description: 'Newsletters, campaigns, and automated sequences'
  },
  {
    value: 'sms',
    label: 'SMS',
    description: 'Text messages sent directly to mobile numbers'
  },
  {
    value: 'push',
    label: 'Push notifications',
    description: 'In-browser or mobile app alerts'
  }
];

export const LIST_OPTIONS = [
  {
    value: 'spreadsheet',
    label: 'In a spreadsheet or CRM',
    description: "I'll upload a CSV or connect my CRM"
  },
  {
    value: 'app',
    label: 'In my app or database',
    description: "I'll sync contacts via API"
  },
  {
    value: 'scratch',
    label: 'Starting from scratch',
    description: "I'm building my list from zero"
  }
];

export const TRANSACTIONAL_OPTIONS = [
  {
    value: 'self',
    label: 'I am the developer',
    description: "I'll handle the API integration myself"
  },
  {
    value: 'team',
    label: 'A developer on my team will integrate it',
    description: "I'll hand the API docs to our developer"
  }
];

export const DNS_OPTIONS = [
  {
    value: 'self',
    label: 'I can handle it myself',
    description: 'I have access to my domain settings'
  },
  {
    value: 'team',
    label: 'Someone on my team will do it',
    description: "I'll pass the instructions to our developer or IT"
  },
  {
    value: 'guided',
    label: "I'll need guidance",
    description: "Not sure what DNS means — I'd prefer a step-by-step walkthrough"
  }
];

export const TIMELINE_OPTIONS = [
  {
    value: 'this_week',
    label: 'This week',
    description: 'I want to get something out as soon as possible'
  },
  {
    value: 'this_month',
    label: 'Within the month',
    description: "I'm setting things up properly before I launch"
  },
  {
    value: 'exploring',
    label: 'Just exploring for now',
    description: "I'm evaluating before committing"
  }
];

const SCREEN_NAMES = ['welcome', 'role', 'goal', 'channels', 'list', 'dns', 'timeline', 'referral'];

export const buildProgressPayload = (
  screen,
  answers,
  time_spent,
  is_transactional,
  show_channels
) => {
  let next_screen;
  if (screen === SCREENS.GOAL && !show_channels) {
    next_screen = 'list';
  } else {
    next_screen = SCREEN_NAMES[screen + 1] || 'referral';
  }
  const payload = { 'onboarding.last_screen_seen': next_screen };

  if (screen === SCREENS.ROLE) {
    payload['qualification.role'] = answers.role;
    payload['onboarding.time_per_question.role'] = time_spent;
  } else if (screen === SCREENS.GOAL) {
    payload['qualification.goal'] = answers.goal;
    payload['onboarding.time_per_question.goal'] = time_spent;
  } else if (screen === SCREENS.CHANNELS) {
    payload['qualification.channels'] = answers.channels;
    payload['onboarding.time_per_question.channels'] = time_spent;
  } else if (screen === SCREENS.LIST) {
    if (is_transactional) {
      payload['qualification.transactional_setup'] = answers.transactional_setup;
    } else {
      payload['qualification.list_situation'] = answers.list_situation;
    }
    payload['onboarding.time_per_question.list'] = time_spent;
  } else if (screen === SCREENS.DNS) {
    payload['qualification.dns_confidence'] = answers.dns_confidence;
    payload['onboarding.time_per_question.dns'] = time_spent;
  } else if (screen === SCREENS.TIMELINE) {
    payload['qualification.timeline'] = answers.timeline;
    payload['onboarding.time_per_question.timeline'] = time_spent;
  }

  return payload;
};
